export enum InvoiceDetailsMessagesColumns {
  Date,
  Message,
  From,
  Direction,
}
